import { render, staticRenderFns } from "./AccountInfo.vue?vue&type=template&id=144b8b5c&scoped=true&"
import script from "./AccountInfo.vue?vue&type=script&lang=ts&"
export * from "./AccountInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144b8b5c",
  null
  
)

export default component.exports